import { AdvancedReceivingVariant } from './MarketingPage/variants/AdvancedReceivingVariant/AdvancedReceivingVariant';
import { MicrositesVariant } from './MarketingPage/variants/MicrositesVariant/MicrositesVariant';
import { MonetizationVariant } from './MarketingPage/variants/MonetizationVariant/MonetizationVariant';
import type { SneakPeekVariant } from './types';

export const localStorage_key_userInterest =
  '2022-Q2-PUBLISH-SNEAK-PEEK_userInterest';

export const localStorage_key_didSeeSneakPeek =
  '2022-Q2-PUBLISH-SNEAK-PEEK_didSeeSneakPeek';

export const localStorage_key_didNavigateToSurvey =
  '2022-Q2-PUBLISH-SNEAK-PEEK_didNavigateToSurvey';

export const micrositesVariant: SneakPeekVariant = {
  name: 'quick-pages',
  surveyUrl: 'https://we-transfer.typeform.com/to/dn47n3X0',
  ContentComponent: MicrositesVariant,
  route: '/quick-pages-sneak-peek',
};

export const advancedReceivingVariant: SneakPeekVariant = {
  name: 'advanced-receiving',
  surveyUrl: 'https://we-transfer.typeform.com/to/zQMFaOQK',
  ContentComponent: AdvancedReceivingVariant,
  route: '/advanced-receiving-sneak-peek',
};

export const monetizationVariant: SneakPeekVariant = {
  name: 'pay-to-download',
  surveyUrl: 'https://we-transfer.typeform.com/to/uj23X0O2',
  ContentComponent: MonetizationVariant,
  route: '/pay-to-download-sneak-peek',
};
